/* tslint:disable */

/**
 * grpc/client_data/client-data.service.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Валюта. Номера значений зафиксированы и совпадают со SMALLINT-кодами в БД сервисов (deals.currency и т.д.) — менять их нельзя.   - CURRENCY_VND: Вьетнамский донг (основная валюта)  - CURRENCY_USD: Доллар США  - CURRENCY_RUB: Российский рубль
 * @export
 * @enum {string}
 */

export const V1Currency = {
  Unspecified: 'CURRENCY_UNSPECIFIED',
  Vnd: 'CURRENCY_VND',
  Usd: 'CURRENCY_USD',
  Rub: 'CURRENCY_RUB',
} as const

export type V1Currency = (typeof V1Currency)[keyof typeof V1Currency]
